'use client';

import React from 'react';

import { Typography } from '@mui/material';
// import { useMediaQuery, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import styled from 'styled-components';

import LazyArticles from './lazyArticles';
import { addTypeAndParentSlugToTopics } from '../../../../product/[slug]/utils';
// import BreadcrumbsWrap from '@/ui/components/BreadcrumbsWrap';
// import SideMenu from '@/ui/components/SideMenu';
// import LayoutContainer from '@/ui/containers/layout/LayoutContainer';
// import OutsideBox from '@/ui/containers/layout/OutsideBox';
// import StillNeedHelp from '@/ui/containers/StillNeedHelp';

export const Headline = styled.div`
  padding-bottom: 40px;
  padding-top: 20px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    padding-bottom: 2rem;
    padding-top: 2rem;
  }
`;

// const ProductWrap = styled.div`
//   display: grid;
//   grid-template-columns: minmax(auto, 730px) minmax(auto, 400px);
//   gap: 40px;
//   justify-content: space-between;

//   ${({ theme }) => theme.breakpoints.down('md')} {
//     display: flex;
//     flex-flow: column;
//     gap: 0;

//     > div {
//       order: 3;
//     }
//   }
// `;

// const Main = styled.main`
//   max-width: 730px;

//   ${({ theme }) => theme.breakpoints.down('md')} {
//     max-width: none;
//     order: 2;
//   }
// `;
interface ProductProps {
  articles: ArticleData[];
  product: Product;
  topics: CategoryData[];
  topic: CategoryData;
  topicSlug: string;
  // articlesPerPage: number;
}

const Topic: React.FC<ProductProps> = ({
  articles,
  product,
  topics,
  topic,
  topicSlug,
  // articlesPerPage,
}) => {
  // const breadcrumbProduct = {
  //   ...product,
  //   title: product.content,
  //   type: 'products',
  // };

  addTypeAndParentSlugToTopics(topics, product.slug);

  // const isMdUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));

  return (
    <>
      {/* <BreadcrumbsWrap items={[breadcrumbProduct, { name: topic.title }]} />

      <Headline>
        <Typography variant="h1">{product.content} support</Typography>
      </Headline>

      <OutsideBox /> */}

      {/* <ProductWrap> */}
      {/* <Main> */}
      <Box mt={6}>
        <Typography variant="h3" component="h2">
          {topic.title}
        </Typography>

        <Box mt={2}>
          {articles && (
            <LazyArticles
              initialArticles={articles}
              productSlug={product.slug}
              categorySlug={topicSlug}
              // articlesPerPage={articlesPerPage}
            />
          )}
        </Box>
      </Box>
      {/* </Main> */}

      {/* {isMdUp ? (
          <>
            <AsideContent topics={topics} />
          </>
        ) : (
          <AsideContent topics={topics} />
        )}
      </ProductWrap>

      <LayoutContainer noPadding>
        <StillNeedHelp />
      </LayoutContainer> */}
    </>
  );
};

/**
 * @todo Useful links
 */
// const AsideContent = ({ topics }) => (
//   <Box mt={6}>
//     <SideMenu heading="topics" items={topics} />
//   </Box>
// );

export default Topic;
